import { InjectionToken } from '@angular/core';
import type {
  PosInitResult, CartData, CartResult, CheckoutData, CheckoutResult,
  ProductFilterParams, OfflineProduct, OfflineStock, CreateMovementData, OfflineWarehouse, SuccessResult,
  OfflineChartOfAccount, JournalEntryFilterParams, OfflineJournalEntry, CreateJournalEntryData, OfflineFiscalYear,
  EmployeeFilterParams, OfflineEmployee, CreateEmployeeData, LeaveRequestFilterParams, OfflineLeaveRequest,
  CreateLeaveRequestData, PayRunFilterParams, OfflinePayRun,
  PurchaseOrderFilterParams, OfflinePurchaseOrder, CreatePurchaseOrderData, ReceivePurchaseOrderData,
} from './types/offline-models';

export interface PosDataProvider {
  getInit(warehouseId: number): Promise<PosInitResult>;
  calculate(cart: CartData): Promise<CartResult>;
  checkout(data: CheckoutData): Promise<CheckoutResult>;
}

export interface InventoryDataProvider {
  getProducts(params: ProductFilterParams): Promise<OfflineProduct[]>;
  getStocks(warehouseId: number): Promise<OfflineStock[]>;
  createMovement(data: CreateMovementData): Promise<SuccessResult>;
  getWarehouses(): Promise<OfflineWarehouse[]>;
}

export interface AccountingDataProvider {
  getChartOfAccounts(): Promise<OfflineChartOfAccount[]>;
  getJournalEntries(params: JournalEntryFilterParams): Promise<OfflineJournalEntry[]>;
  createJournalEntry(data: CreateJournalEntryData): Promise<SuccessResult>;
  getFiscalYears(): Promise<OfflineFiscalYear[]>;
}

export interface HrDataProvider {
  getEmployees(params: EmployeeFilterParams): Promise<OfflineEmployee[]>;
  createEmployee(data: CreateEmployeeData): Promise<SuccessResult>;
  getLeaveRequests(params: LeaveRequestFilterParams): Promise<OfflineLeaveRequest[]>;
  createLeaveRequest(data: CreateLeaveRequestData): Promise<SuccessResult>;
  getPayRuns(params: PayRunFilterParams): Promise<OfflinePayRun[]>;
}

export interface PurchaseDataProvider {
  getPurchaseOrders(params: PurchaseOrderFilterParams): Promise<OfflinePurchaseOrder[]>;
  createPurchaseOrder(data: CreatePurchaseOrderData): Promise<SuccessResult>;
  receivePurchaseOrder(id: number, data: ReceivePurchaseOrderData): Promise<SuccessResult>;
}

export const POS_DATA_TOKEN = new InjectionToken<PosDataProvider>('POS_DATA');
export const INVENTORY_DATA_TOKEN = new InjectionToken<InventoryDataProvider>('INVENTORY_DATA');
export const ACCOUNTING_DATA_TOKEN = new InjectionToken<AccountingDataProvider>('ACCOUNTING_DATA');
export const HR_DATA_TOKEN = new InjectionToken<HrDataProvider>('HR_DATA');
export const PURCHASE_DATA_TOKEN = new InjectionToken<PurchaseDataProvider>('PURCHASE_DATA');
